import { useTranslation } from 'react-i18next';
import { Button } from '../Buttons/Button';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';

const AttentionModal = () => {
  const { t } = useTranslation();
  const { modalProps, closeModal } = useModalContext<{ rejectBonus: () => void }>();
  return (
    <ModalWrapper>
      <div className=" flex flex-col gap-6 p-[24px] w-[300px] r_xsm:w-full">
        <div className="text-2xl font-bold uppercase text-center text-am_title mt-5">
          {t('modalCancelBonus.attention')}!
        </div>
        <div className="text-lg font-bold text-center text-am_text">
          {t('modalCancelBonus.text')}
        </div>
        <div className="flex flex-col gap-7 items-center w-full">
          <div className="flex items-center justify-center w-full">
            <Button
              mode="button-primary"
              title={`${t('modalCancelBonus.sure')}`}
              label={`${t('modalCancelBonus.sure')}`}
              onClick={() => {
                modalProps?.rejectBonus();
                closeModal();
              }}
            />
          </div>
          <div className="flex items-center justify-center w-full mb-6">
            <Button
              title={`${t('modalCancelBonus.save')}`}
              mode="button-secondary"
              onClick={closeModal}
              label={`${t('modalCancelBonus.save')}`}
            />
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default AttentionModal;
